
































































































































































































import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import SlideIn from '@/components/basic/SlideIn.vue';
import { stAccountApi } from '@/services/st-api';
import StBadge from '@/components/basic/StBadge.vue';
import { ContractDataViewModel } from '@/services/api/nswag/stapiclient_generated';

//@ts-ignore
import * as FileSaver from 'file-saver';
import { UserStore } from "@/store/user-module";

Component.registerHooks(['beforeRouteUpdate']);

@Component({
  components: {
    StBadge,
    SlideIn,
  },
})
export default class Payment extends Vue {
  private contractData: ContractDataViewModel = ContractDataViewModel.fromJS({ invoiceData: [], licenseData: {}, paymentData: {}, invoices: [] });
  loading: boolean = true;

  beforeRouteUpdate(to: any, from: any, next: any) {
    next();
    if (to.name == 'Payment') {
      this.loadData();
    }
  }

  async loadData() {
    this.contractData = await stAccountApi.getContractData();
    this.loading = false;
  }

  async mounted() {
    await this.loadData();
  }

  get usePassiveUsers(){
    return UserStore.userSettings.featureFlagPassiveUsers;
  }

  get showBasicUserInputs(){
    return (UserStore.userSettings.featureFlagPassiveUsers || UserStore.userSettings.featureFlagMixedUsers) && !UserStore.userSettings.useBasicTimeTracking
  }

  goToAccountInvoiceData() {
    this.$router.push({ name: 'EditAccountInvoiceData' });
  }

  goToPaymentData() {
    this.$router.push({ name: 'EditPaymentData' });
  }

  goToLicenseData() {
    this.$router.push({ name: 'EditLicenseData' });
  }

  async downloadInvoice(id: number) {
    let fileData = await stAccountApi.getInvoicePdf(id);
    FileSaver.saveAs(fileData.data, fileData.fileName);
  }
}
